import { IClickElement } from './base-element';

export class PortalActionEvent {
  public static EVENT_NAME: string = 'PortalActionEvent';

  constructor(
    public element: IClickElement,
    public options: any,
    public type: 'SUBMIT' | 'CHANGE',
  ) {}
}
